import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Pill, Clock } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SuplementacaoPage() {
  const [supplements, setSupplements] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try { const { data } = await axios.get(`${API}/api/my-supplements`); setSupplements(data); } catch {} finally { setLoading(false); }
  }, []);
  useEffect(() => { fetch(); }, [fetch]);

  if (loading) return <div className="text-center py-12 text-brand-muted">A carregar...</div>;

  return (
    <div className="fade-in" data-testid="suplementacao-page">
      <div className="mb-6">
        <h2 className="font-heading font-medium text-xl text-brand-text">A minha suplementação</h2>
        <p className="text-sm text-brand-muted mt-0.5">Suplementos definidos pela tua nutricionista</p>
      </div>

      {supplements.length === 0 ? (
        <div className="text-center py-16">
          <Pill size={48} className="mx-auto text-brand-placeholder mb-4" weight="duotone" />
          <p className="text-brand-muted">Sem suplementação definida.</p>
          <p className="text-xs text-brand-placeholder mt-1">A tua nutricionista pode definir suplementos para ti.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {supplements.map((s, i) => (
            <div key={i} className="bg-white border border-brand-border rounded-2xl p-4 flex items-center gap-4" data-testid={`supplement-${i}`}>
              <div className="w-10 h-10 rounded-xl bg-brand-mint/15 flex items-center justify-center flex-shrink-0 overflow-hidden">
                {s.image_path ? <img src={`${API}/api/files/${s.image_path}`} alt="" className="w-full h-full object-cover" /> : <Pill size={20} weight="duotone" className="text-brand-green" />}
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-brand-text">{s.name}</p>
                <p className="text-xs text-brand-muted">{s.dose}{s.notes ? ` · ${s.notes}` : ''}</p>
                {s.indication && <p className="text-[10px] text-brand-placeholder mt-0.5">{s.indication}</p>}
              </div>
              {s.time && (
                <div className="flex items-center gap-1 text-xs text-brand-muted flex-shrink-0">
                  <Clock size={13} /> {s.time}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
